/** Max page size for callers that need a single broad fetch (e.g. client access, invoice tools). */
export const MANAGE_LIST_FETCH_PAGE_SIZE = 100;

/** Paginated list envelope from GET b2b/manage/accounts and .../campaigns */
export interface ManagedPaginatedResult<T> {
  items: T[];
  total_objects: number;
  total_pages: number;
  page: number;
  page_size: number;
}

export interface Account {
  id: string;
  account_id?: string;
  created_at: string;
  updated_at: string;
  status: string | null;
  ext_account_id: string;
  title: string;
  source: string;
  attention_needed: boolean;
  company: string | null;
}

export interface GetAccountsApiResponse {
  accounts: Account[];
}

/** GET b2b/manage/accounts — query params only */
export interface GetAccountsParams {
  page?: number;
  /** Default on server is all results; client UI typically sends 25–100 (max 100). */
  page_size?: number;
  /** Case-insensitive match on title */
  search?: string;
  attention_needed?: boolean;
}

export interface UpdateAccountParams {
  accountId: string;
  title?: string;
  company?: string | null;
  source?: string;
  ext_account_id?: string;
  attention_needed?: boolean;
  status?: string;
}

/** Nested AccountInternal on campaign list/detail (read-only object; PATCH uses account UUID). */
export interface CampaignAccount {
  id: string;
  ext_account_id: string;
  title: string;
  source: string;
  attention_needed: boolean;
  company: string | null;
  status?: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface Campaign {
  id: string;
  account: CampaignAccount;
  created_at: string;
  updated_at: string;
  status: string | null;
  ext_campaign_id: string;
  title: string;
  platform: string;
  channel?: string | null;
  attention_needed: boolean;
  /** Present on CampaignInternal list/detail */
  hide?: boolean;
  do_not_bill: boolean;
  pre_billed: boolean;
  sku: string | null;
  company: string | null;
  owner?: string | null;
  /** Legacy / optional if present on some responses */
  invoice?: string | null;
  invoice_line_item?: string | null;
}

/** GET b2b/manage/campaigns — query params only */
export interface GetCampaignsParams {
  page?: number;
  /** Default on server is all results; client UI typically sends 25–100 (max 100). */
  page_size?: number;
  /** Case-insensitive match on title */
  search?: string;
  attention_needed?: boolean;
}

export interface UpdateCampaignParams {
  campaignId: string;
  title?: string;
  company?: string | null;
  sku?: string | null;
  attention_needed?: boolean;
  pre_billed?: boolean;
  do_not_bill?: boolean;
  hide?: boolean;
  platform?: string;
  channel?: string | null;
  ext_campaign_id?: string;
  /** Account FK (UUID); nested `account` on GET is read-only */
  account?: string | null;
  owner?: string | null;
  status?: string;
}

export interface ClientSurveyAccess {
  client_survey_id: string;
  client_id: string;
  ext_survey_id: string;
}